import React, { useEffect } from 'react';
import {
	Button,
	Modal,
	ModalHeader,
	ModalBody,
	Spinner,
} from 'reactstrap';

import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import { deleteWorkStatus } from '../../../../../slices/workStatus/thunk';
import { setRequireCloseModal } from '../../../../../slices/workStatus/reducer';
import { Icons } from '../../../../../utils/Icons';

const DeleteWorkStatusModal = ({ dataWorkStatus, isOpen, handlerToggleModal, toggleRefetch }) => {
	const dispatch = useDispatch();

	const selectorWorkStatus = createSelector(
		state => state.WorkStatus,
		data => ({
			isDeleting: data.isDeleting,
			isDeleted: data.isDeleted,
			isDeleteError: data.isDeleteError,
			isLoadingList: data.isLoadingList,
			requireCloseModal: data.requireCloseModal,
		})
	);

	const { isDeleting, requireCloseModal } = useSelector(selectorWorkStatus);

	useEffect(() => {
		if (isOpen) {
			if (requireCloseModal) {
				dispatch(setRequireCloseModal(false));
				handlerToggleModal();
				if (toggleRefetch) {
					setTimeout(() => {
						toggleRefetch();
					}, 100);
				}
			}
		}
	}, [requireCloseModal]);

	function handlerDelete() {
		dispatch(deleteWorkStatus(dataWorkStatus));
	}

	return (
		<div>
			<Modal
				isOpen={isOpen}
				toggle={() => handlerToggleModal()}
				size='sm'
				className='border-0'
				modalClassName='modal fade zoomIn'
				backdrop={'static'}
				centered={true}
			>
				<ModalHeader className='modal-title' />
				<ModalBody className='text-center p-3'>
					<lord-icon
						src='https://cdn.lordicon.com/tdrtiskw.json'
						trigger='loop'
						colors='primary:#f06548,secondary:#405189'
						style={{ width: '90px', height: '90px' }}
					></lord-icon>
					<div className='mt-2'>
						<h3 className='mb-3'>
							¡Estás a punto de eliminar un estado de actividad!
						</h3>
						<p className='text-muted mb-4'>
							Si deseas realizar esta acción debes hacer click en
							confirmar.
						</p>
						<p className='small'>
							Estado de Actividad: {dataWorkStatus !== null ? dataWorkStatus.name : ''}
						</p>
						<div className='hstack gap-2 justify-content-center'>
							<Button className='btn-danger btn-label' onClick={() => handlerToggleModal()}>
								<i className='icon-x label-icon'></i> Cancelar
							</Button>
							<button className='btn btn-label btn-primary' onClick={() => handlerDelete()} disabled={isDeleting}>
								{isDeleting ? (<i className='label-icon'><Spinner size='sm' /></i>) : <i className={`${Icons.check2} label-icon`}></i>} Confirmar
							</button>
						</div>
					</div>
				</ModalBody>
			</Modal>
		</div>
	);
};

export default DeleteWorkStatusModal;
